import { useController } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import { RadioButtonGroup, SettingsFormItem } from '@/modules/forms';

import { Fields, SharingPermission } from '../../constants';

export interface SharingPermissionFieldProps {
    onChange: () => void;
}

const name = Fields.SHARING_PERMISSION;

export const SharingPermissionField = ({ onChange }: SharingPermissionFieldProps) => {
    const {
        field: { ref, ...field },
    } = useController({ name });

    return (
        <SettingsFormItem name={name} label={<FormattedMessage id='settings.form.sharingPermission.label' />}>
            <RadioButtonGroup
                {...field}
                onChange={e => {
                    field.onChange(e.target.value);
                    onChange();
                }}
                optionType='button'
                options={[SharingPermission.EVERYONE, SharingPermission.ADMIN_ONLY, SharingPermission.DISALLOWED].map(value => ({
                    label: <FormattedMessage id={`settings.form.sharingPermission.${value}`} />,
                    value,
                }))}
            />
        </SettingsFormItem>
    );
};
